import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { CampanhaSelectModule } from '../../../../campanhas/campanhas/components/select';
import { CNAEsViewModule } from '../../../../cnaes/components/cnaes-view';
import { CNAEPipeModule } from '../../../../cnaes/pipes';
import { CanalVendaInputGroupModule } from '../../../../common/canais-venda/components/input-group';
import { CanalVendaSelectModule } from '../../../../common/canais-venda/components/select';
import { CanalMidiaSocialSelectModule } from '../../../../common/canal-midia-social/components/select';
import { CanalMidiaSocialInputGroupModule } from '../../../../common/canal-midia-social/components/input-group';
import { CapitalSocialFormControlTextModule } from '../../../../common/capital-social/form-control-text';
import { EmpresaSituacaoCadastralModule } from '../../../../common/empresa-situacao-cadastral';
import { IdentificadorMatrizFilialModule } from '../../../../common/identificador-matriz-filial';
import { MEIFormModule } from '../../../../common/mei';
import { NaturezaJuridicaFormControlModule } from '../../../../common/natureza-juridica/components/form-control';
import { OrigemSelectModule } from '../../../../common/origens/components/select';
import { OrigemInputGroupModule } from '../../../../common/origens/components/input-group';
import { PorteEmpresaFormControlModule } from '../../../../common/porte-empresa/components/form-control';
import { SimplesNacionalFormModule } from '../../../../common/simples-nacional';
import { SocioViewModule } from '../../../../common/socios/view';
import { TemperaturaSelectModule } from '../../../../common/temperatura/select';
import { PessoaTipoPipeModule } from '../../../../pessoa/tipo/pipes';
import { PessoaTipoCardControlRadioModule } from '../../../../pessoa/tipo/card-control-radio';
import { UsuarioSelectModule } from '../../../../usuario/select';
import { LeadClassificacaoFormModule } from '../../classificacao/form';
import { LeadContatoModule } from '../../contato';
import { LeadEnderecoModule } from '../../endereco';
import { RegiaoSelectModule } from '../../../../regiao/select';

import { LeadFormComponent } from './lead-form.component';
import { LeadPreInsertFormComponent } from './pre-insert';

@NgModule({
    imports: [
        SharedModule,
        OrigemSelectModule,
        OrigemInputGroupModule,
        TemperaturaSelectModule,
        LeadContatoModule,
        LeadEnderecoModule,
        LeadClassificacaoFormModule,
        UsuarioSelectModule,
        CampanhaSelectModule,
        CanalVendaInputGroupModule,
        CanalVendaSelectModule,
        CanalMidiaSocialSelectModule,
        CanalMidiaSocialInputGroupModule,
        PorteEmpresaFormControlModule,
        NaturezaJuridicaFormControlModule,
        IdentificadorMatrizFilialModule,
        CNAEsViewModule,
        CNAEPipeModule,
        SimplesNacionalFormModule,
        MEIFormModule,
        CapitalSocialFormControlTextModule,
        SocioViewModule,
        EmpresaSituacaoCadastralModule,
        PessoaTipoPipeModule,
        PessoaTipoCardControlRadioModule,
        RegiaoSelectModule
    ],
    declarations: [
        LeadPreInsertFormComponent,
        LeadFormComponent
    ],
    exports: [
        LeadFormComponent
    ]
})
export class LeadFormModule { }
